<template>
  <section class="asc-plot-data-tab-list--container">
    <div ref="list" class="asc-plot-data-tab-list--content">
      <asc-plot-data-tab
        v-for="(tab, index) in dataTabs"
        :key="index"
        :active="activeTab === index"
        :tab-index="tab.tabIndex"
        :icon="tab.icon"
        :icon-color="tab.iconColor"
        :title="tab.title"
        :hidden="tab.hidden"
        :is-tab-menu-disabled="isTabMenuDisabled"
        :number-tabs="dataTabs.length"
        :number-visible-tabs="getNumberVisibleTabs"
        :readonly="isReadOnly(index)"
        :saving="saving"
        :disabled="disabled"
        :error="displayErrorMessage && tab.error"
        @click="handleTabClick(index)"
        @remove="handleTabRemoval"
        @updateTabView="handleUpdateTabView"
      />
    </div>
    <template v-if="editable && !readonly">
      <div class="asc-plot-data-tab-list--button--container">
        <asc-accent-button
          class="asc-plot-data-tab-list--button"
          button-text
          icon-only
          icon="add"
          :on-click="handleNewTab"
          secondary
          :disabled="getDisableAddButton"
        />
      </div>
    </template>
  </section>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscPlotDataTab from '@/components/molecules/AscPlotDataTab'

export default {
  name: 'AscPlotDataTabList',

  components: {
    AscAccentButton,
    AscPlotDataTab,
  },

  props: {
    pagePlot: {
      type: Object,
      default: () => {},
    },
    plottingDataTabs: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: null,
    },
    maxTabs: {
      type: Number,
      default: 10,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    displayErrorMessage: {
      type: Boolean,
      default: false,
    },
    isTabMenuDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activeTab: this.value,
      dataTabs: this.plottingDataTabs,
    }
  },

  computed: {
    getDisableAddButton() {
      return this.plottingDataTabs.length === this.maxTabs
    },

    getNumberVisibleTabs() {
      return this.plottingDataTabs.filter(item => !item.hidden).length
    },
  },

  watch: {
    activeTab(newValue) {
      this.activeTab = newValue
      this.$emit('update:value', newValue)
      this.$emit('input', newValue)
    },

    plottingDataTabs(newValue) {
      this.dataTabs = newValue
      const plotList = this.$refs.list
      this.$nextTick(() => (plotList.scrollLeft = plotList.scrollWidth))
    },

    value(newValue) {
      this.activeTab = newValue
    },
  },

  methods: {
    isReadOnly(tabIndex) {
      const prepopulated = this.pagePlot?.prepopulated || false
      if (prepopulated) {
        return this.dataTabs[tabIndex].prepopulated
      }

      return this.readonly || this.disabled || !this.editable
    },

    handleTabClick(tabIndex) {
      this.activeTab = tabIndex
    },

    handleUpdateTabView(tab) {
      this.$emit('updateTabView', tab)
    },

    handleTabRemoval(tabIndex) {
      this.$emit('deleteTab', tabIndex)
    },

    handleNewTab() {
      this.$emit('addTab')
    },
  },
}
</script>

<style lang="scss">
.asc-plot-data-tab-list {
  &--button.asc-accent-button-container > .asc-accent-button--accent {
    min-width: 36px;
  }

  &--button {
    margin-left: 8px;
    margin-top: 2px;
    min-width: 36px;
    margin-bottom: 10px;
  }

  &--container {
    display: flex;
    overflow: hidden;

    .asc-plot-data-tab-list--button--container {
      padding-top: 6px;
    }
  }

  &--content {
    align-items: center;
    display: flex;
    flex: 0 1 auto;
    flex-flow: row nowrap;
    overflow-x: auto;
    overflow-y: hidden;

    & > .asc-plot-data-tab--container {
      margin-right: 1px;
    }
  }
}
</style>
